import { FC } from 'react'

import styled from 'styled-components'

import { device, variables } from 'src/Styled/variables'

import { StripeImages } from '../PaymentMethods/StripeImages'

interface StripeCardInfoProps {
  cardInfo?: string
}

const CardInfo = styled.div`
  color: ${({ theme }) => theme.color.slateGrey};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-transform: uppercase;
  line-height: 150%;
`
const StyledSpan = styled.span`
  font-size: ${variables.fontSize14};
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.color.slateGrey};

  font-weight: ${variables.fontWeight400};
  white-space: break-spaces;
`
const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  @media ${device.mobileMin} {
    flex-direction: row;
  }
`

export const StripeCardInfo: FC<StripeCardInfoProps> = ({ cardInfo }) => {
  if (cardInfo) {
    return <CardInfo>{cardInfo}</CardInfo>
  }
  return (
    <Container>
      <StyledSpan>Сredit & debit сards</StyledSpan>
      <StripeImages />
    </Container>
  )
}
